import { createApp } from 'vue';
import ExhibitorRegistration from '../vue/ExhibitorRegistration.vue';

class ExhibitorRegistrationJs {
    constructor() {
        this.container = document.querySelector('.js-exhibitor-registration-container');
        if (this.container) {
            this.initExhibitorRegistration();
        }
    }

    // eslint-disable-next-line class-methods-use-this
    initExhibitorRegistration() {
        const app = createApp({});
        app.component('ExhibitorRegistration', ExhibitorRegistration);
        app.mount('#exhibitor-registration');
        return app;
    }
}

export default ExhibitorRegistrationJs;
